type SchemaGapNoteProps = {
  note: string;
};

export function SchemaGapNote({ note }: SchemaGapNoteProps) {
  return (
    <div className="mb-4 border border-dashed border-black/40 bg-muted/20 p-3 text-sm">
      <span className="font-semibold">ໝາຍເຫດ:</span> {note}
    </div>
  );
}
